export const SDK_VERSION = '7.37.2';
